import styled from 'styled-components';
export const WarningBoxWrapper = styled.div `
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 0.5rem;
  font-size: 12px;
  background: #fbf9d0;
  color: #5e5a08;
  border-radius: 0.5rem;
  svg {
    padding-right: 0.5rem;
  }
`;
export const WarningText = styled.p `
  padding: 3px;
  margin: 0;
`;
